import React from "react";
import ProductOne from "../../image/ProductOne.png";
const data = [
  {
    id: 1,
    icon: ProductOne,
    title: "Base Coat",
    list: [
      "B.C Binder Clear",
      "B.C Binder milky",
      "B.C White",
      "B.C Black",
      "B.C Brilliant Red",
      "B.C Blue",
      "B.C Fine Silver 1120",
      "B.C Medium Silver 1150",
      "B.C Coarse Silver 1170",
      "Pearl White",
      "Pearl Blue",
      "Pearl Green",
      "Pearl Red",
      "Pearl Brown",
      "Pearl Yellow Gold",
      "Pearl Gold",
    ],
  },
  {
    id: 2,
    icon: ProductOne,
    title: "Acrylic Paints 2K",
    list: [
      "2K White",
      "2K Jet Black",
      "2K Mixing Black",
      "2K Yellow Oxide",
      "2K Yellow Lemone",
      "2K Yellow Chrome",
      "2K Red Oxide",
      "2K Red Brilliant",
      "2K Red Orange",
      "2K Maroon",
      "2K Violet",
      "2K Blue",
      "2K Green",
      "2K Matt Agent",
    ],
  },
  {
    id: 3,
    icon: ProductOne,
    title: "NC Paints",
    list: [
      "Nc White",
      "Nc Black Matt",
      "N.C Black Gloss",
      "Nc Yellow Oxide",
      "Nc Yellow Lemone",
      "Nc Yellow Chrome",
      "Nc Red Oxide",
      "Nc Red Brilliant",
      "Nc Red Orange",
      "Nc Maroon",
      "Nc Blue",
      "Nc Green",
      "Nc Fine Silver 1120",
      "Nc Medium Silver 1150",
      "Nc Coarse Silver 1170",
      "Nc Primer (Gray)",
      "Nc Clear Coat",
      "Nc Sealer",
    ],
  },
  {
    id: 4,
    icon: ProductOne,
    title: "Synthetic Paints",
    list: [
      "Syn White",
      "Syn Black",
      "Syn Yellow Lemon",
      "Syn Yellow Oxide",
      "Syn Yellow Chrome",
      "Syn Red",
      "Syn Red Oxide",
      "Syn Red Orange",
      "Syn Orange",
      "Syn Green",
      "Syn Maroon",
      "Syn Blue",
      "Syn Violet",
      "Syn Fine Silver",
      "Syn Medium Silver",
      "Syn Coarse Silver",
    ],
  },
  {
    id: 5,
    icon: ProductOne,
    title: "Thinners",
    list: [
      "2K Thinner 5 1tr",
      "105 Thinner 1 Gal",
      "NC Thinner Gal",
      "Cleaning Thinner Gal",
    ],
  },
  {
    id: 6,
    icon: ProductOne,
    title: "Paint Accessories",
    list: [
      "2K Clear Coat 1L + Hardener",
      "2K Clear Coat 1L ",
      "2K Clear Coat Matt 1L ",
      "2K Primer + Hardener ",
      "2K Fast Hardener 1/2L",
      "2K MS Hardener 1/2L ",
      "2K Slow Hardener 1/2L",
      "Bumper Primer 1L",
      "Bumper Primer 1/2L",
    ],
  },
];

export default data;
